import React from 'react'
import { usePutRequest } from '../hooks/request'
import ServerError from './common/ServerError'
import useTrans from '../hooks/trans'
import DocsCategoryForm from './DocsCategoryForm'
import { CATEGORY_DETAIL } from '../urls'

export default function DocsCategoryUpdate({ onCancel, onUpdate, item }) {
    const url = CATEGORY_DETAIL.replace('{id}', item.id)
    const categoryUpdate = usePutRequest({ url })
    const t = useTrans()

    async function onSubmit(data, actions) {
        const { success } = await categoryUpdate.request({ data })

        if (success) {
            actions.resetForm()
            onUpdate()
        }
    }

    return (
        <div>
            <b>{t('editing')}</b><br /><br />
            <ServerError error={categoryUpdate.error} />
            <DocsCategoryForm
                initialValues={item}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={categoryUpdate.loading} />
        </div>
    )
}
